import { SalesforceEventName } from "./salesforce-events.types";

export type SalesforceAttributeType = "Text" | "Number" | "Boolean";

export interface SalesforceAttributeSchema {
  name: string;
  type: SalesforceAttributeType;
  maxLength?: number;
}

/**
 * Schema canônico recebido em eventos_schema_sorocaba_ajustes.csv.
 * A ordem das chaves é preservada no payload para facilitar o QA nos logs.
 */
export const SALESFORCE_EVENT_SCHEMA: Record<
  SalesforceEventName,
  readonly SalesforceAttributeSchema[]
> = {
  sf_adicionar_carrinho: [
    { name: "eventid", type: "Text", maxLength: 100 },
    { name: "userid", type: "Text", maxLength: 100 },
    { name: "nome_produto", type: "Text", maxLength: 100 },
    { name: "marca", type: "Text", maxLength: 100 },
    { name: "vendido_entregue_por", type: "Text", maxLength: 100 },
    { name: "detalhes_do_produto", type: "Text", maxLength: 100 },
    { name: "valor", type: "Number" },
    { name: "cor", type: "Text", maxLength: 100 },
    { name: "quantidade", type: "Number" },
    { name: "cep", type: "Text", maxLength: 100 },
    { name: "favorito", type: "Text", maxLength: 100 },
    { name: "id_carrinho", type: "Text", maxLength: 100 },
    { name: "nome_evento", type: "Text", maxLength: 100 },
  ],
  sf_busca: [
    { name: "eventid", type: "Text", maxLength: 100 },
    { name: "userid", type: "Text", maxLength: 100 },
    { name: "nome_produto", type: "Text", maxLength: 100 },
    { name: "nome_evento", type: "Text", maxLength: 100 },
  ],
  sf_busca_filtro: [
    { name: "eventid", type: "Text", maxLength: 100 },
    { name: "userid", type: "Text", maxLength: 100 },
    { name: "departamento", type: "Text", maxLength: 100 },
    { name: "categoria", type: "Text", maxLength: 100 },
    { name: "subcategoria", type: "Text", maxLength: 100 },
    { name: "preco_min", type: "Number" },
    { name: "preco_max", type: "Number" },
    { name: "marca", type: "Text", maxLength: 100 },
    { name: "caracteristica", type: "Text", maxLength: 100 },
    { name: "anvisa", type: "Text", maxLength: 100 },
    { name: "nome_da_cor", type: "Text", maxLength: 100 },
    { name: "nome_evento", type: "Text", maxLength: 100 },
  ],
  sf_cadastro: [
    { name: "eventid", type: "Text", maxLength: 100 },
    { name: "userid", type: "Text", maxLength: 100 },
    { name: "razao_social", type: "Text", maxLength: 100 },
    { name: "cpf_cnpj", type: "Text", maxLength: 100 },
    { name: "celular", type: "Text", maxLength: 100 },
    { name: "email", type: "Text", maxLength: 100 },
    { name: "nome_evento", type: "Text", maxLength: 100 },
    { name: "telefone_comercial", type: "Text", maxLength: 100 },
    { name: "nome", type: "Text", maxLength: 100 },
    { name: "sobrenome", type: "Text", maxLength: 100 },
    { name: "data_nascimento", type: "Text", maxLength: 100 },
  ],
  sf_cadastro_empresa: [
    { name: "eventid", type: "Text", maxLength: 100 },
    { name: "userid", type: "Text", maxLength: 100 },
    { name: "nome_estabelecimento", type: "Text", maxLength: 100 },
    { name: "area_atuacao", type: "Text", maxLength: 100 },
    { name: "tipo_estabelecimento", type: "Text", maxLength: 100 },
    { name: "cep", type: "Text", maxLength: 100 },
    { name: "endereco_de_entrega", type: "Text", maxLength: 100 },
    { name: "numero", type: "Number" },
    { name: "complemento", type: "Text", maxLength: 100 },
    { name: "ponto_de_referencia", type: "Text", maxLength: 100 },
    { name: "bairro", type: "Text", maxLength: 100 },
    { name: "cidade", type: "Text", maxLength: 100 },
    { name: "estado", type: "Text", maxLength: 100 },
    { name: "identidade", type: "Text", maxLength: 100 },
    { name: "comprovante_de_endereco", type: "Text", maxLength: 100 },
    { name: "estabelecimento_fachada", type: "Text", maxLength: 100 },
    { name: "pedidos_feitos_por_app", type: "Boolean" },
    { name: "status_estabelecimento", type: "Text", maxLength: 100 },
    { name: "dias_disponiveis_recebimento", type: "Text", maxLength: 100 },
    { name: "horarios_disponiveis_entrega", type: "Text", maxLength: 100 },
  ],
  sf_carrinho: [
    { name: "eventid", type: "Text", maxLength: 100 },
    { name: "userid", type: "Text", maxLength: 100 },
    { name: "id_carrinho", type: "Text", maxLength: 100 },
    { name: "valor_total_sem_frete", type: "Number" },
    { name: "valor_por_unidade", type: "Number" },
    { name: "nome", type: "Text", maxLength: 100 },
    { name: "nome_cupom", type: "Text", maxLength: 100 },
    { name: "unidade", type: "Number" },
    { name: "quantidade_total", type: "Number" },
    { name: "valor_frete", type: "Number" },
    { name: "nome_evento", type: "Text", maxLength: 100 },
  ],
  sf_compra: [
    { name: "eventid", type: "Text", maxLength: 100 },
    { name: "userid", type: "Text", maxLength: 100 },
    { name: "valor_total_sem_frete", type: "Number" },
    { name: "valor_total_venda", type: "Number" },
    { name: "valor_frete", type: "Number" },
    { name: "id_pedido", type: "Text", maxLength: 100 },
    { name: "tipo_entrega", type: "Text", maxLength: 100 },
    { name: "forma_pagamento", type: "Text", maxLength: 100 },
    { name: "nome_produto", type: "Text", maxLength: 100 },
  ],
  sf_pagamento: [
    { name: "eventid", type: "Text", maxLength: 100 },
    { name: "userid", type: "Text", maxLength: 100 },
    { name: "metodo_pagamento", type: "Text", maxLength: 100 },
    { name: "tipo_entrega", type: "Text", maxLength: 100 },
    { name: "valor_total_sem_frete", type: "Number" },
    { name: "valor_total_venda", type: "Number" },
    { name: "valor_frete", type: "Number" },
    { name: "id_carrinho", type: "Text", maxLength: 100 },
    { name: "nome_evento", type: "Text", maxLength: 100 },
  ],
  sf_page_view: [
    { name: "eventid", type: "Text", maxLength: 100 },
    { name: "userid", type: "Text", maxLength: 100 },
    { name: "nome_pagina", type: "Text", maxLength: 100 },
    { name: "nome_evento", type: "Text", maxLength: 100 },
  ],
  sf_remover_carrinho: [
    { name: "eventid", type: "Text", maxLength: 100 },
    { name: "userid", type: "Text", maxLength: 100 },
    { name: "nome_produto", type: "Text", maxLength: 100 },
    { name: "marca", type: "Text", maxLength: 100 },
    { name: "codigo", type: "Text", maxLength: 100 },
    { name: "vendido_entregue_por", type: "Text", maxLength: 100 },
    { name: "preco_de", type: "Number" },
    { name: "preco_por", type: "Number" },
    { name: "quantidade", type: "Number" },
    { name: "id_carrinho", type: "Text", maxLength: 100 },
    { name: "nome_evento", type: "Text", maxLength: 100 },
  ],
};
